export default __webpack_public_path__ + "static/media/Old2.1b6d7ccc.svg";